import React from 'react';
import { useChatContext } from 'stream-chat-react';

import { Typography } from '@mui/material';

import { checkRole } from '@common/components/RBAC';

import { useConfig } from '../../config';
import { getWorkingHoursString } from '../../config/WorkHours';
import * as Styled from './styled';

function ChannelListHeaderWorkTimeInfo() {
	const { channel } = useChatContext();

	const workHours = useConfig(getWorkingHoursString);

	if (channel?.data?.type !== 'messaging') return null;

	if (checkRole('Teacher') || checkRole('Mentor/Tutor')) return null;

	return (
		<Styled.TextWrap>
			<Typography color="text.secondary" variant="body2">
				Mon-Fri:
			</Typography>
			<Typography color="text.primary" variant="body2" fontWeight={600}>
				{workHours}
			</Typography>
		</Styled.TextWrap>
	);
}

export default ChannelListHeaderWorkTimeInfo;
